export default __webpack_public_path__ + "static/418-249b23e8fda3ce8634177c49417d6f5a.gif";